import React, { useEffect } from 'react';
import { SidebarProps as Props } from '../';
import style from '../new.module.scss';
import { dialogTypes, responseTypes, eventTypes } from '../../constants';
import { Select } from '../../../../components';
import { Actions, AddRecognizes } from './';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../../../stateManager/store';

export function Sidebar(props: Props) {
	const { selectedApp } = useSelector((state: RootState) => state.apps)
	const {
		messageRespOpened,
		updateDialogByKey,
		dialog,
		updateDialogByKeyValue,
		errors,
		clearError,
	} = props;
	const isServiceEnabled = dialog.responseType === 'service';

	useEffect(() => {
		if(dialog.responseType === "message") {
			props.viewMessageResp(true);
		}
	}, [])

	return (
		<div data-message-resp-opened={messageRespOpened} className={style.sidebar}>
			<div>
				<label htmlFor="title" className={style.label}>
					Title
				</label>
				<input
					value={dialog.title}
					onChange={(e) => {
						updateDialogByKey('title', e.target.value);
					}}
					id="title"
					className={style.input}
					placeholder="Enter title here..."
				/>
				{errors.title?.length > 0 && (
					<span className={style.error}>{errors.title}</span>
				)}
			</div>

			<div>
				<label htmlFor="dialogType" className={style.label}>
					{selectedApp.chatType === 'genai' ? 'Events' : 'Dialog Type' }
				</label>
				{selectedApp.chatType === 'genai' ? (
					<div className={style.dialogType} style={{display: "block"}}>
						<div style={selectDialogValueStyles}>
							<Select
								customLabel={(() => {
									const tokens = dialog.dialogValue.split('.');
									if (tokens.length == 2) {
										const event = eventTypes.find(
											(el) => el.value === tokens[0],
										);
										return event!.label + ' / ' + tokens[1];
									}
									return undefined;
								})()}
								placeholder="Select Event"
								value={dialog.dialogValue}
								options={eventTypes.filter((item) => item.value !== 'nlp')}
								onSelect={(value) => {
									const tokens = value.split(':');
									if (tokens.length == 2) {
										updateDialogByKey('dialogValue', tokens.join('.'));
									}
								}}
							/>
						</div>
					</div>
				) : <div className={style.dialogType}>
					<div style={selectDialogTypeStyles}>
						<Select
							placeholder="Dialog type"
							value={dialog.dialogType}
							options={dialogTypes}
							onSelect={(value: any) => {
								updateDialogByKeyValue({
									dialogType: value,
									dialogValue: '',
								});
							}}
						/>
					</div>
					<div className={style.line} />
					{dialog.dialogType === 'intent' ? (
						<input
							value={dialog.dialogValue}
							onChange={(e) => {
								updateDialogByKey('dialogValue', e.target.value);
							}}
							id="dialog"
							placeholder="Enter intent here"
						/>
					) : (
						<div style={selectDialogValueStyles}>
							<Select
								customLabel={(() => {
									const tokens = dialog.dialogValue.split('.');
									if (tokens.length == 2) {
										const event = eventTypes.find(
											(el) => el.value === tokens[0],
										);
										return event!.label + ' / ' + tokens[1];
									}
									return undefined;
								})()}
								placeholder="Select Event"
								value={dialog.dialogValue}
								options={eventTypes}
								onSelect={(value) => {
									const tokens = value.split(':');
									if (tokens.length == 2) {
										updateDialogByKey('dialogValue', tokens.join('.'));
									}
								}}
							/>
						</div>
					)}
				</div>}
				{errors.dialogValue?.length > 0 && (
					<span className={style.error}>{errors.dialogValue}</span>
				)}
			</div>

			<AddRecognizes {...props} />

			<div>
				<label htmlFor="response" className={style.label}>
					Response
				</label>
				<Select
					placeholder="Select response type"
					options={responseTypes}
					onSelect={(value: any) => {
						updateDialogByKey('responseType', value);
						if (value === 'message') {
							props.setIsNewAction(false)
							props.selectAction("")
							props.viewMessageResp(true);
						} else {
							props.viewMessageResp(false);
						}
						clearError("messages")
					}}
					value={dialog.responseType}
				/>
				{errors.responseType?.length > 0 && (
					<span className={style.error}>{errors.responseType}</span>
				)}
				{errors.messages?.length > 0 && (
					<span className={style.error}>{errors.messages}</span>
				)}
			</div>

			{dialog.responseType === 'flow' && (
				<>
					<div>
						<label htmlFor="flows" className={style.label}>
							Flow
						</label>
						<Select
							placeholder="Select flow"
							options={props.flows}
							onSelect={(value: any) => {
								clearError('flowName');
								updateDialogByKey("flowName", value)
								updateDialogByKey("nodeId", "")
							}}
							value={dialog.flowName}
						/>
						{errors.flowName?.length > 0 && (
							<span className={style.error}>{errors.flowName}</span>
						)}
					</div>
					<div>
						<label htmlFor="startNode" className={style.label}>
							Start Node
						</label>
						<Select
							placeholder="Default Start Node"
							options={[{label: "Default Start Node", value: "DEFAULT"}, ...props.nodes]}
							onSelect={(value: any) => value == "DEFAULT" ? updateDialogByKey('nodeId', "") : updateDialogByKey('nodeId', value)}
							value={dialog.nodeId}
						/>
						{errors.nodeId?.length > 0 && (
							<span className={style.error}>{errors.nodeId}</span>
						)}
					</div>
				</>
			)}

			{isServiceEnabled && (
				<>
					<div>
						<label htmlFor="serviceKey" className={style.label}>
							Service
						</label>
						<Select
							placeholder="Select service"
							options={props.services}
							onSelect={(value: any) => updateDialogByKey('serviceKey', value)}
							value={dialog.serviceKey}
						/>
						{errors.serviceKey?.length > 0 && (
							<span className={style.error}>{errors.serviceKey}</span>
						)}
					</div>
					<div>
						<Actions {...props} />
						{errors.actions?.length > 0 && (
							<span className={style.error}>{errors.actions}</span>
						)}
					</div>
				</>
			)}
		</div>
	);
}

const selectDialogTypeStyles: Record<string, string> = {
	'--select-width': '103px',
	'--select-chat-border': 'none',
	'--select-space': '0px',
	'--select-top': '7px',
	'--select-options-top': '33px',
	'--select-options-left': '-16px',
};

const selectDialogValueStyles: Record<string, string> = {
	'--select-width': '100%',
	'--select-options-width': '175px',
	'--select-options-top': '33px',
	'--select-options-left': '-16px',
	'--select-chat-border': 'none',
	'--select-space': '0px',
	'--select-top': '7px',
};
